import axios from 'axios';
import * as Cookies from '../utils/cookies';

export async function addNewMatchToRound(
  league_pk,
  round_pk,
  group1,
  group2,
  time,
  court
) {
  const token = Cookies.getToken();

  try {
    const res = await axios({
      method: 'POST',
      url:
        process.env.REACT_APP_API_URL +
        `/api/league/leagues/${league_pk}/rounds/${round_pk}/matches/`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        teams: [group1, group2],
        court: court,
        start_time: time,
      },
    });
    return res;
  } catch (error) {
    return { error: error };
  }
}

